import React, { useState } from 'react';
import collegeConfig from '../../config/collegeConfig';
import { FaTimes, FaSave, FaSpinner } from 'react-icons/fa';

// Shared "Request Reattempt" flow used by both HOD (ViewLogbooks) and Dean (DeanDashboard) —
// guarantees identical behavior since both call the same POST /entries/:id/request-reattempt route.
// Reuses global modal/button classes already defined in ViewLogbooks.css.
const ReattemptRequestModal = ({ entry, moduleName, onClose, onSuccess, onError }) => {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('token');

      const response = await fetch(
        `${collegeConfig.api.baseURL}/logbook/entries/${entry._id}/request-reattempt`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ note })
        }
      );

      if (response.ok) {
        const data = await response.json();
        onSuccess(data.entry);
        onClose();
      } else {
        throw new Error('Failed to request reattempt');
      }
    } catch (error) {
      console.error('Error requesting reattempt:', error);
      if (onError) onError('Failed to request reattempt');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="verification-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-sticky">
          <h3>Request Reattempt</h3>
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="student-info-modal">
            <div className="info-row">
              <span>Student:</span>
              <strong>
                {entry?.studentId?.profile?.firstName} {entry?.studentId?.profile?.lastName}
              </strong>
            </div>
            <div className="info-row">
              <span>Module:</span>
              <strong>{moduleName}</strong>
            </div>
          </div>

          <div className="verification-form">
            <div className="form-group">
              <label>Note (Optional)</label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Explain why this needs to be redone..."
                rows="3"
              />
            </div>
          </div>
        </div>

        <div className="modal-footer-sticky">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-submit btn-reattempt-action"
            onClick={handleSubmit}
            disabled={saving}
          >
            {saving ? (
              <>
                <FaSpinner className="spinner" />
                Saving...
              </>
            ) : (
              <>
                <FaSave />
                Request Reattempt
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReattemptRequestModal;
